import { api } from '.';

import { ApiRoutes } from '@/constant/api';

import { PassRequestType } from '@/types/passes';
import { PersonPassesResponseType } from '@/types/person';

const passesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		createPass: builder.mutation<null, PassRequestType>({
			query: ({ id, body }) => ({
				url: `${ApiRoutes.Persons}/${id}/pass`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Passes'],
		}),
		updatePass: builder.mutation<null, PassRequestType>({
			query: ({ id, body }) => ({
				url: `${ApiRoutes.Passes}/${id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['Passes', 'PersonPasses'],
		}),
		deletePass: builder.mutation<null, number>({
			query: (id) => ({
				url: `${ApiRoutes.Passes}/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Passes'],
		}),
		getPersonPasses: builder.query<PersonPassesResponseType, number>({
			query: (personId) => ({
				url: `${ApiRoutes.Persons}/${personId}/pass`,
			}),
			providesTags: ['PersonPasses'],
		}),
	}),
});

export const {
	useCreatePassMutation,
	useDeletePassMutation,
	useUpdatePassMutation,
	useLazyGetPersonPassesQuery,
} = passesApi;
